// (C) Copyright 2025 Hewlett Packard Enterprise Development LP

import { useState } from 'react'
import { Box, Video, Skeleton, Stack } from 'grommet'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { Loader } from '../../../components'

const VideoWithSkeleton = ({ videoId, src }) => {
  const [videoLoading, setVideoLoading] = useState(true)
  const handleVideoLoad = () => setVideoLoading(false)
  const { t } = useTranslation(['common'])

  return (
    <Box>
      {videoLoading && (
        <Stack anchor="center">
          <Skeleton height="small" round="xsmall" />
          <Box align="center">
            <Loader testId={`video-loader-${videoId}`} label={t('loading')} />
          </Box>
        </Stack>
      )}
      <Video
        controls="over"
        fit="contain"
        alignSelf="start"
        data-testid={`video-${videoId}`}
        onLoadedMetadata={handleVideoLoad}
        onPlaying={handleVideoLoad}
        style={{ display: videoLoading ? 'none' : 'block' }}
      >
        <source
          data-testid={`video-source-${videoId}`}
          src={src}
          type="video/mp4"
        />
      </Video>
    </Box>
  )
}

VideoWithSkeleton.propTypes = {
  videoId: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired
}

export default VideoWithSkeleton
